/**
 * ------------------------------------------------------------
 * 必須入力項目
 */
// See views/leads/new.html.erb

/**
 * ------------------------------------------------------------
 * オプション入力項目
 */
// toggle selected/unselected
$(document).on(
  'change',
  '#js-lead-form [name="lead[contract_type]"]',
  function () {
    const selected = $('#js-lead-form [name="lead[contract_type]"]:checked');
    if (selected.val() === 'contract_type_unknown') {
      hideLeadFormOptionFields();
    } else {
      showLeadFormOptionFields();
    }
  }
);

function showLeadFormOptionFields() {
  $('tr.selected').show();
  $('tr.unselected').hide();
}

function hideLeadFormOptionFields() {
  $('tr.selected').hide();
  $('tr.unselected').show();
}

/**
 * ------------------------------------------------------------
 * ご相談内容
 */
// reset inquiry_to when the value is NOT inquiry_type_change
// disable inquiry_to when the value is NOT inquiry_type_change
// add required when the value is inquiry_type_change
$(document).on(
  'change',
  '#js-lead-form [name="lead[contract_type]"]',
  function () {
    const selected = $('#js-lead-form [name="lead[contract_type]"]:checked');
    if (selected.val() !== 'contract_type_change') {
      $('#js-lead-form [name="lead[inquiry_to]"]').val('inquiry_to_unknown');
      $('#js-lead-form [name="lead[inquiry_to]"]').closest('tr').hide();
      $('#js-lead-form [name="lead[inquiry_to]"]').prop('disabled', true);
      // $('#js-lead-form [name="lead[inquiry_to]"]').prop('required', false);
    } else {
      $('#js-lead-form [name="lead[inquiry_to]"]').closest('tr').show();
      $('#js-lead-form [name="lead[inquiry_to]"]').prop('disabled', false);
      // $('#js-lead-form [name="lead[inquiry_to]"]').prop('required', true);
    }
  }
);
